// extracted by mini-css-extract-plugin
export default {"personailty":"PersonalityFactors-module__personailty__EFJan","factorContainer":"PersonalityFactors-module__factorContainer__QwsVA"};